/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_AugustInputs */

const he_month_august = /** @type {(inputs: Month_AugustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אוגוסט`)
};

const en_month_august = /** @type {(inputs: Month_AugustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`August`)
};

/**
* | output |
* | --- |
* | "August" |
*
* @param {Month_AugustInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_august = /** @type {((inputs?: Month_AugustInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_AugustInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_august(inputs)
	return en_month_august(inputs)
});